'use client'
import React, { FunctionComponent, useCallback, useState } from 'react'
import cn from 'classnames'
import styles from './MktuClassAnnotation.module.scss'
import { Icon } from '@/icons'
import Link from 'next/link'

interface MktuClassAnnotaionProps {
  explanation: string
  included: string[][]
  excluded: string[][]
  withClassLinks?: boolean
  defaultRollup?: boolean
}
export const MktuClassAnnotation: FunctionComponent<
  MktuClassAnnotaionProps
> = ({
  explanation,
  included,
  excluded,
  withClassLinks,
  defaultRollup = false,
}) => {
  const [rollup, setRollup] = useState(defaultRollup)

  const click = useCallback(() => {
    setRollup((r) => !r)
  }, [])

  return (
    <div>
      <button className={styles.button} type="button" onClick={click}>
        <span>Пояснения к классу</span>
        <Icon
          name="rollup"
          className={cn(styles.icon, { [styles.isRollup]: rollup })}
        />
      </button>

      <div
        className={cn(styles.content, {
          [styles.hidden]: !rollup,
        })}
      >
        <div className={styles.title}>Пояснения</div>
        <div className={styles.annotation}>{explanation}</div>
        <div>
          {included.length !== 0 ? (
            <div className={styles.block}>
              <div className={styles.listTitle}>
                <Icon
                  name="check"
                  stroke="#00866B"
                  className={styles.iconCheck}
                />{' '}
                К классу относятся, в частности
              </div>
              <div className={styles.list}>
                {included.map((item) => (
                  <ExplanationOption
                    key={item.join('')}
                    data={item}
                    withClassLink={withClassLinks}
                  />
                ))}
              </div>
            </div>
          ) : null}
          {excluded.length !== 0 ? (
            <div className={styles.block}>
              <div className={styles.listTitle}>
                <Icon
                  name="close"
                  stroke="#F06438"
                  className={styles.iconCheck}
                />{' '}
                К классу не относятся, в частности
              </div>
              <div className={styles.list}>
                {excluded.map((item) => (
                  <ExplanationOption
                    key={item.join('')}
                    data={item}
                    withClassLink={withClassLinks}
                  />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

interface ExplanationOptionProps {
  data: string[]
  withClassLink?: boolean
}
const ExplanationOption: FunctionComponent<ExplanationOptionProps> = ({
  data,
  withClassLink,
}) => {
  const withLink = withClassLink === true

  return (
    <div className={styles.item}>
      {data.map((item, i) =>
        /\$\d\d/.test(item) ? (
          <React.Fragment key={item + i}>
            (
            <ClassItem
              key={item + i}
              isLink={withLink}
              itemNumber={item.slice(1)}
            />
            )
          </React.Fragment>
        ) : (
          <React.Fragment key={item + i}>{item}</React.Fragment>
        )
      )}
    </div>
  )
}

interface ClassItemProps {
  isLink: boolean
  itemNumber: string
}
const ClassItem: FunctionComponent<ClassItemProps> = ({
  isLink,
  itemNumber,
}) => {
  if (isLink) {
    return (
      <Link
        href={`/mktu/classes/${Number(itemNumber)}`}
        className={styles.itemClassLink}
      >
        кл. {itemNumber}
      </Link>
    )
  }
  return <span className={styles.itemClassLink}>кл. {itemNumber}</span>
}
